<i18n locale="en" lang="json">
{
  "pageTitle": "Not authorised",
  "message": "You have no rights to consult this data. Proceed to [Home](/)"
}
</i18n>
<i18n locale="nl" lang="json">
{
  "pageTitle": "Niet geautoriseerd",
  "message": "U heeft geen rechten om deze gegevens te raadplegen. Ga verder naar [Home](/)"
}
</i18n>

<template>
  <the-page-title :title="t('pageTitle')" test-id="unauthorized" />
  <the-title-bar
    :title="t('pageTitle')"
    :back-button-location="{ name: RouteName.HomeIndex }"
  />
  <base-page>
    <base-alert type="warning">
      <markdown :content="t('message')" />
    </base-alert>
  </base-page>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>
